export default "__VITE_ASSET__DwV2hFYL__"